/**
 * Summary data service
 * Handles clinical summary storage and retrieval
 */

import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "./firebase";

/**
 * Save summary for a question
 * @param {string} questionId
 * @param {string} summaryText
 */
export const saveSummary = async (questionId, summaryText) => {
  await setDoc(doc(db, "summaries", questionId), {
    questionId,
    text: summaryText,
    createdAt: serverTimestamp(),
  });
};

/**
 * Get summary for a question
 * @param {string} questionId
 * @returns {string}
 */
export const getSummary = async (questionId) => {
  const snap = await getDoc(doc(db, "summaries", questionId));
  if (!snap.exists()) return null;
  return snap.data().text;
};
